import React, { memo, useContext } from 'react'

import { Container } from './styles'
import { GlobalContext } from '../../../contexts/GlobalContext'
import Header from '../../../pages/LandingPage/Header'
import Footer from '../../../pages/LandingPage/Footer'

const LandingPageDefaultLayout = memo(({ children, userData }) => {
	const { clienteRobot } = useContext(GlobalContext)

	if(!clienteRobot) {
		return null
	}

	return (
		<Container>
			<div className="min-h-screen bg-background text-foreground">
				<Header />

				{children}

				<Footer />
			</div>
		</Container>
	)
})

export default LandingPageDefaultLayout
